import React, { useState, useEffect } from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
  } from 'chart.js';
import {Line} from 'react-chartjs-2';
import * as actions from "../store/actions";
import {connect} from "react-redux";
import moment from "moment/moment";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
  );

//   export const options = {
//     responsive: true,
//     plugins: {
//       legend: {
//         position: 'top' as const,
//       },
//       title: {
//         display: true,
//         text: 'Chart.js Line Chart',
//       },
//     },
//   };

function TotalsChart(props){

    const [labels, setLabels] = useState([]);
    const [myData, setMyData] = useState([]);
    const [trials, setTrials] = useState([]);

    useEffect(()=>{
        if (props.role === "admin"){
            props.onGetStatsChartAdmin(props.token, props.name);
        } else if (props.role === "manager"){
            props.onGetStatsChartSuperReseller(props.token, props.name);
        } else if (props.role === "reseller"){
            props.onGetStatsChartReseller(props.token, props.name);
        }
        
        console.log('label', labels);
        console.log('mydata', myData);
        console.log('trials', trials);
    },[]);

    useEffect(() => {
        if (props.clients && props.clients.length){
            setLabels(props.labels);
            setMyData(props.clients);
            setTrials(props.trials);
            console.log('label', labels);
        console.log('mydata', myData);
        console.log('trials', trials);
        }
    },[props.clients]);

    const options = {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
          legend: {
            position: 'top',
          },
          title: {
            display: true,
            text: 'Total Users History',
          },
        },
      };

    const data = {
        labels: labels,
        datasets: [
            {
                label: 'Active Users',
                fill: false,
                lineTension: 0.1,
                backgroundColor: 'rgba(75,192,192,0.4)',
                borderColor: 'rgba(75,192,192,1)',
                borderCapStyle: 'butt',
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'miter',
                pointBorderColor: 'rgba(75,192,192,1)',
                pointBackgroundColor: '#fff',
                pointBorderWidth: 1,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                pointHoverBorderColor: 'rgba(220,220,220,1)',
                pointHoverBorderWidth: 2,
                pointRadius: 1,
                pointHitRadius: 10,
                data: myData
            },
            {
                label: 'Trials',
                fill: false,
                lineTension: 0.1,
                backgroundColor: 'rgba(235,119,52, 0.4)',
                borderColor: 'rgba(235,119,60,1)',
                borderCapStyle: 'butt',
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'miter',
                pointBorderColor: 'rgba(75,192,192,1)',
                pointBackgroundColor: '#fff',
                pointBorderWidth: 1,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                pointHoverBorderColor: 'rgba(220,220,220,1)',
                pointHoverBorderWidth: 2,
                pointRadius: 1,
                pointHitRadius: 10,
                data: trials
            }
        ]
    };

    return (
        <div style={{ position: "relative", margin: "0px", width: "99%" }}>
            <Line options={options} data={data} />
        </div>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        onGetStatsChartAdmin: (token, name) => dispatch(actions.getStatsChartAdmin(token, name)),
        onGetStatsChartSuperReseller: (token, name) => dispatch(actions.getStatsChartSuperReseller(token, name)),
        onGetStatsChartReseller: (token, name) => dispatch(actions.getStatsChartReseller(token, name)),
        //onGetStatsChartDealer: (token) => dispatch(actions.getTotalStatsChartDealer(token))
    }
};

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        //currentSuperResellerName: state.superReseller.name,
        labels: state.statsChart.on_date,
        clients: state.statsChart.clients,
        trials: state.statsChart.trials,
        //currentSuperReseller: state.superReseller.item,
        //isLoadingSuperReseller: state.superReseller.loading,
        //isErrorSaveSuperReseller: state.saveSuperReseller.error,
        //isSuccessSaveSuperReseller: state.saveSuperReseller.super_reseller,
        //isLoadingSaveSuperReseller: state.saveSuperReseller.loading
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TotalsChart);
